import { render, staticRenderFns } from "./DxWeatherForecast.vue?vue&type=template&id=28d68dda&"
import script from "./DxWeatherForecast.vue?vue&type=script&lang=js&"
export * from "./DxWeatherForecast.vue?vue&type=script&lang=js&"
import style0 from "./DxWeatherForecast.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports